module.exports = __webpack_public_path__ + "img/av.ed9fe3b6.svg";